// extracted by mini-css-extract-plugin
export default {"fabRoot":"StudentDashboard_fabRoot__YnyQS"};